import styles from './profile-editor.module.scss'
import { SelectorButton } from '@/components/atomic/SelectorButton'
import {
  LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS,
  LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS_VALUES,
} from '@/lib/constants'

export const InitialPaymentInMonths = ({
  initialPaymentInMonths,
  availableFilters,
  onChangeInitialPayment,
}) => {
  return (
    <div
      className={styles.section}
      data-filter="initial-payment-in-months">
      <h3>Upfront payment</h3>
      <div className={`${styles['scroll-area']} carousel__container`}>
        <div className={styles['scroll-group']}>
          {LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS_VALUES.map(value => {
            return (
              <SelectorButton
                key={value}
                onChangeParameter={onChangeInitialPayment}
                filter={LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS}
                filterValue={value}
                activeValue={initialPaymentInMonths}
                availableFilters={availableFilters}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}
